(() => {
  const root = document.querySelector('[data-npd]');
  if (!root) return;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const p = JSON.parse($('[data-npd-product]').textContent);
  const cfg = JSON.parse($('[data-npd-config]').textContent);
  const fmt = root.dataset.moneyFormat || '$';
  const L = '{' + '{', R = '}' + '}';
  const money = c => {
    const a = fmt.indexOf(L), b = fmt.indexOf(R), n = c / 100;
    if (a < 0 || b < 0) return '$' + n.toFixed(2);
    const k = fmt.slice(a + 2, b).trim();
    let v = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (k === 'amount_no_decimals') v = Math.round(n).toLocaleString('en-US');
    if (k === 'amount_with_comma_separator') v = n.toFixed(2).replace('.', ',');
    return fmt.slice(0, a) + v + fmt.slice(b + 2);
  };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const names = p.options.map(o => typeof o === 'string' ? o : o.name);
  const iColor = names.findIndex(n => /colou?r/i.test(n));
  const iPack = names.findIndex(n => /pack/i.test(n));
  const iSize = names.findIndex(n => /size/i.test(n) && !/pack/i.test(n));
  const values = names.map((_, i) => [...new Set(p.variants.map(v => v.options[i]))]);
  let cur = p.variants.find(v => String(v.id) === String(cfg.variant)) || p.variants[0];
  const qv = new URLSearchParams(location.search).get('variant');
  if (qv) { const f = p.variants.find(v => String(v.id) === qv); if (f) cur = f; }
  const sel = [...cur.options];
  const packN = v => { const m = String(v || '').match(/(\d+)\s*pack/i); return m ? +m[1] : 1; };
  const packPct = v => { const m = String(v || '').match(/(\d+)\s*%/); return m ? +m[1] : 0; };
  const find0 = s => p.variants.find(v => v.options.every((o, i) => o === s[i]));
  if (!qv) {
    const trial = [...sel];
    if (iPack > -1) { const f = values[iPack].find(x => packN(x) === 4); if (f) trial[iPack] = f; }
    if (iSize > -1 && values[iSize].includes('Large')) trial[iSize] = 'Large';
    const tv = find0(trial);
    if (tv && tv.available) trial.forEach((x, i) => { sel[i] = x; });
  }
  const file = u => String(u || '').split('?')[0].split('/').pop().toLowerCase().replace(/[-_]/g, '');
  const imgFor = (color, n) => {
    if (!color) return null;
    let key = color.toLowerCase().replace(/[-_ ]/g, '');
    if (key === 'undyed') key = 'natural';
    const toks = [n + 'pack', n + 'pk'];
    return p.images.find(u => file(u).includes(key) && toks.some(t => file(u).includes(t))) ||
      p.images.find(u => file(u).includes(key) && (file(u).includes('1pack') || file(u).includes('1pk')));
  };
  const find = s => p.variants.find(v => v.options.every((o, i) => o === s[i]));
  const avail = (i, val) => p.variants.some(v => v.options[i] === val && v.available && v.options.every((o, j) => j === i || o === sel[j]));
  const variantWith = (i, val) => find(sel.map((s, j) => j === i ? val : s)) || p.variants.find(v => v.options[i] === val);
  const limited = String(cfg.limited || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  let showAllColors = false;
  const lines = t => String(t || '').split('\n').map(s => s.trim()).filter(Boolean).map(s => s.split('|'));

  function render() {
    const v = find(sel);
    let html = '';
    if (iColor > -1) {
      const n = iPack > -1 ? packN(sel[iPack]) : 1;
      const cols = values[iColor];
      const shown = showAllColors ? cols : cols.slice(0, 5);
      html += `<div class="npd__lbl">Colors: <span>${esc(sel[iColor])}</span></div><div class="npd__sw">`;
      shown.forEach(c => {
        const vv = variantWith(iColor, c);
        const im = imgFor(c, n) || imgFor(c, 1) || (vv && vv.featured_image && vv.featured_image.src) || p.featured_image;
        const tag = c.toLowerCase() === String(cfg.topColor || '').toLowerCase() ? '<span class="tag top">🔥 Top Seller</span>' : (limited.includes(c.toLowerCase()) ? '<span class="tag">Limited Edition</span>' : '');
        html += `<button type="button" class="npd__swb${sel[iColor] === c ? ' is-on' : ''}" data-opt="${iColor}" data-val="${esc(c)}" title="${esc(c)}" aria-label="${esc(c)}">${tag}<img src="${im}${String(im).includes('?') ? '&' : '?'}width=200" alt=""></button>`;
      });
      if (!showAllColors && cols.length > 5) html += `<button type="button" class="npd__more" data-more>+${cols.length - 5}</button>`;
      html += '</div>';
    }
    if (iPack > -1) {
      const packs = [...values[iPack]].sort((a, b) => packN(a) - packN(b));
      const n = packN(sel[iPack]);
      html += `<div class="npd__lbl">Quantity: <span>${n} — US ${v ? money(Math.round(v.price / n)) : ''} each</span></div><div class="npd__packs">`;
      packs.forEach(pk => {
        const vv = variantWith(iPack, pk); const k = packN(pk); const pct = packPct(pk);
        const price = vv ? vv.price : 0;
        const perks = lines(cfg['perks' + k]);
        const badge = k === 4 ? '<span class="npd__badge">🔥 Most Popular</span>' : (k === 8 ? '<span class="npd__badge alt">✰ Best Value</span>' : '');
        html += `<button type="button" class="npd__pack${sel[iPack] === pk ? ' is-on' : ''}" data-opt="${iPack}" data-val="${esc(pk)}">${badge}<span class="dot"></span>
          <span><b>${k === 1 ? 'Single' : k + ' Pack'}${pct ? ` <em>- Save ${pct}%</em>` : ''}</b><small>${money(Math.round(price / k))}/pair</small></span>
          <span class="pr">${money(price)}</span>
          ${perks.length ? `<span class="npd__perks">${perks.map(x => `<div><span>✓ ${esc(x[0])}</span>${x[1] ? `<s>${esc(x[1])}</s>` : ''}</div>`).join('')}</span>` : ''}</button>`;
      });
      html += '</div>';
    }
    if (iSize > -1) {
      html += `<div class="npd__lbl"><span style="font-weight:800">Size: <span style="font-weight:500">${esc(sel[iSize] || '')}</span></span>${cfg.runsSmall ? `<span class="warn">${esc(cfg.runsSmall)}</span>` : ''}<button type="button" data-sg-open>Updated size guide</button></div><div class="npd__sizes">`;
      values[iSize].forEach(s => { html += `<button type="button" class="npd__size${sel[iSize] === s ? ' is-on' : ''}" data-opt="${iSize}" data-val="${esc(s)}" ${avail(iSize, s) ? '' : 'disabled'}>${esc(s)}</button>`; });
      html += '</div>';
    }
    names.forEach((nm, i) => {
      if (i === iColor || i === iPack || i === iSize || (values[i].length < 2)) return;
      html += `<div class="npd__lbl">${esc(nm)}: <span>${esc(sel[i])}</span></div><div class="npd__sizes">` + values[i].map(s => `<button type="button" class="npd__size${sel[i] === s ? ' is-on' : ''}" data-opt="${i}" data-val="${esc(s)}">${esc(s)}</button>`).join('') + '</div>';
    });
    $('[data-npd-options]').innerHTML = html;

    const n = iPack > -1 ? packN(sel[iPack]) : 1;
    $('[data-npd-packlabel]').textContent = n > 1 ? `(${n} Pack)` : '';
    $('[data-npd-price]').textContent = v ? money(v.price) : '';
    $('[data-npd-atc-price]').textContent = v ? money(v.price) : '';
    const atc = $('[data-npd-atc]');
    atc.disabled = !v || !v.available;
    $('[data-npd-atc-label]').textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
    const im = (iColor > -1 && imgFor(sel[iColor], n)) || (v && v.featured_image && v.featured_image.src);
    if (im) setMain(im);
    if (v) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
  }
  function setMain(src) {
    const img = $('[data-npd-main]');
    img.src = src + (String(src).includes('?') ? '&' : '?') + 'width=1100';
    $$('.npd__thumb').forEach(t => t.classList.toggle('is-on', file(t.dataset.file) === file(src)));
  }

  root.addEventListener('click', async e => {
    const o = e.target.closest('[data-opt]');
    if (o && !o.disabled) { sel[+o.dataset.opt] = o.dataset.val; $('[data-npd-err]').textContent = ''; render(); return; }
    if (e.target.closest('[data-more]')) { showAllColors = true; render(); return; }
    const t = e.target.closest('.npd__thumb');
    if (t) { $('[data-npd-main]').src = t.dataset.src; $$('.npd__thumb').forEach(x => x.classList.toggle('is-on', x === t)); return; }
    if (e.target.closest('[data-sg-open]')) { $('[data-npd-sg]').classList.add('is-on'); return; }
    if (e.target.closest('[data-npd-sg-close]') || e.target.matches('[data-npd-sg]')) { $('[data-npd-sg]').classList.remove('is-on'); return; }
    const atc = e.target.closest('[data-npd-atc]');
    if (atc) {
      const v = find(sel);
      if (!v) { $('[data-npd-err]').textContent = 'This combination is not available. Pick another option.'; return; }
      atc.disabled = true; $('[data-npd-atc-label]').textContent = 'Adding…';
      try {
        const r = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
        location.href = root.dataset.cartUrl || '/cart';
      } catch (err) { $('[data-npd-err]').textContent = err.message; atc.disabled = false; $('[data-npd-atc-label]').textContent = 'Add to cart'; }
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $('[data-npd-sg]').classList.remove('is-on'); });
  if (location.hash === '#size-guide') { const d = document.getElementById('size-guide'); if (d) { d.open = true; d.scrollIntoView({ block: 'center' }); } }
  render();
})();